import { render, staticRenderFns } from "./BrandLogosWidgetStackedLayout.vue?vue&type=template&id=6456b359&scoped=true"
import script from "./BrandLogosWidgetStackedLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrandLogosWidgetStackedLayout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BrandLogosWidgetStackedLayout.vue?vue&type=style&index=0&id=6456b359&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6456b359",
  null
  
)

export default component.exports